export default __webpack_public_path__ + "static/media/logo.461e8c45.svg";